import React, { AnchorHTMLAttributes, MutableRefObject } from 'react'

import ExternalLink from '~/components/atoms/link/ExternalLink'
import InternalLink from '~/components/atoms/link/InternalLink'
import { IconColor } from '~/components/atoms/icon/Icon'

interface Props extends AnchorHTMLAttributes<HTMLAnchorElement> {
  link: string
  external?: boolean
  onClick?(e: React.MouseEvent<HTMLElement>): void
  color?: IconColor
  anchorRef?: MutableRefObject<HTMLAnchorElement>
}

const SwitchLink = ({children, link, external = false, onClick = null, color = null, anchorRef = null, ...props}: Props) => {
  return (
    <>
      {link ?
        <>
          {external ?
            <ExternalLink link={link} color={color} anchorRef={anchorRef} {...props}>
              {children}
            </ExternalLink> :
            <InternalLink link={link} anchorRef={anchorRef} {...props}>
              {children}
            </InternalLink>
          }
        </> :
        <>
          {onClick ?
            <a onClick={onClick} ref={anchorRef} {...props}>
              {children}
            </a> :
            <span {...props} ref={anchorRef}>{children}</span>
          }
        </>
      }
    </>
  )
}

export default SwitchLink